import { api } from '@/lib/api';
import { build_params, download_export } from '@/lib/list-query';
import type { SortState } from '@/hooks/use-url-state';
import type {
  BookingCounts,
  BookingDetail,
  BookingListFilters,
  BookingListResponse,
} from './types';

/**
 * The list, with whatever filters and sort are set.
 *
 * Params go through `build_params` rather than a hand-written if-chain: the old
 * version enumerated eight filters by hand, so every filter added to the type
 * had to be remembered here too — and one that was not would look alive on
 * screen while sending nothing.
 */
export async function fetch_booking_list(
  filters: BookingListFilters,
  sort?: SortState,
): Promise<BookingListResponse> {
  const res = await api.get<BookingListResponse>('/admin/bookings', {
    params: build_params(filters as Record<string, never>, sort),
  });
  return res.data;
}

export async function fetch_booking_counts(): Promise<BookingCounts> {
  const res = await api.get<BookingCounts>('/admin/bookings/counts');
  return res.data;
}

export async function export_bookings(
  filters: BookingListFilters,
  sort?: SortState,
): Promise<void> {
  await download_export(
    '/admin/bookings/export',
    build_params(filters as Record<string, never>, sort),
    'bookings.csv',
  );
}

export async function fetch_booking_detail(id: string): Promise<BookingDetail> {
  const res = await api.get<BookingDetail>(`/admin/bookings/${id}`);
  return res.data;
}
